import { render } from "./catalogue.vue?vue&type=template&id=6eefba38&scoped=true"
import script from "./catalogue.vue?vue&type=script&lang=js"
export * from "./catalogue.vue?vue&type=script&lang=js"

import "./catalogue.vue?vue&type=style&index=0&id=6eefba38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eefba38"]])

export default __exports__